import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { Input, Row, Card, Form, DatePicker, Col, Divider, Spin } from "antd";
import ApproveSavingsAcc from "./ApproveSavingsAcc";
import ActivateSavingsAcc from "./ActivateSavingsAcc";
import PostInterestAsOn from "./PostInterestAsOn";
import Deposit from "./Deposit";
import Withdraw from "./Withdraw";
import WithdrawnByApplicantSavingsAcc from "./WithdrawnByApplicantSavingsAcc";
import ModifySavingsAccount from "./editSavingsAccount/ModifySavingsAccount";
import RejectSavingsAcc from "./RejectSavingsAcc";
import UndoApprovalSavingsAcc from "./UndoApprovalSavingsAcc";
import HoldSavingsAcc from "./HoldSavingsAcc";
import AddSavingsAccCharge from "./AddSavingsAccCharge";
import AssignStaffSavingsAcc from "./AssignStaffSavingsAcc";
import CloseSavingsAcc from "./CloseSavingsAcc";
import NewStandingInstruction from "./NewStandingInstruction";
import UnassignStaffSavingsAcc from "./UnassignOfficerSavingsAcc";
import TransferFunds from "./TransferFunds";
import HoldItems from "./HoldItems";
import ManageChequeBookRequest from "./chequeBookRequest/ManageChequeBookRequest";

const { TextArea } = Input;
const SavingsMainActionPage = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // console.log(state);
  }, []);

  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      case "modify application":
        return <ModifySavingsAccount userData={userData} />;
      case "approve":
        return <ApproveSavingsAcc userData={userData} />;
      case "activate":
        return <ActivateSavingsAcc userData={userData} />;
      case "post interest as on":
        return <PostInterestAsOn userData={userData} />;
      case "deposit":
        return <Deposit userData={userData} />;
      case "withdraw":
        return <Withdraw userData={userData} />;
      case "withdrawn by applicant":
        return <WithdrawnByApplicantSavingsAcc userData={userData} />;
      case "reject":
        return <RejectSavingsAcc userData={userData} />;
      case "undo approval":
        return <UndoApprovalSavingsAcc userData={userData} />;
      case "hold":
        return <HoldSavingsAcc userData={userData} />;
      case "unhold":
        return <HoldSavingsAcc userData={userData} />;
      case "add charge":
        return <AddSavingsAccCharge userData={userData} />;

      case "assign officer":
        return <AssignStaffSavingsAcc userData={userData} />;
      case "unassign officer":
        return <UnassignStaffSavingsAcc userData={userData} />;

      case "close":
        return <CloseSavingsAcc userData={userData} />;
      case "transfer funds":
        return <TransferFunds userData={userData} />;
      case "cheque book request":
        return <ManageChequeBookRequest userData={userData} />;
      case "new standing instructions":
        return <NewStandingInstruction userData={userData} />;
      case "hold items":
        return <HoldItems userData={userData} />;
      default:
        return <>No {state?.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(SavingsMainActionPage);
